package pl.decks.personal.components.widgets.ranks.shapes

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSTimeNumericValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.dom.svg.Defs
import com.varabyte.kobweb.compose.dom.svg.DropShadow
import com.varabyte.kobweb.compose.dom.svg.Filter
import com.varabyte.kobweb.compose.dom.svg.Polygon
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.dom.svg.SvgId
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.attr
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import pl.decks.personal.components.widgets.ranks.SVGLine
import pl.decks.personal.components.widgets.ranks.line

@Composable
fun Badge(
    narrowingHeight: Float = 0.15f,
    narrowingWidth: Float = 0.15f,
    backgroundColor: Color = Colors.DarkSlateBlue,
    strokeColor: Color? = null,
    strokeWidth: Float = 2f,
    transitionDur: CSSTimeNumericValue = TransitionDurationVars.Slow.value(),
    modifier: Modifier = Modifier,
) {
    val width = 100f
    val height = 100f
    val widthMiddle = width * 0.5f
    val widthNarrowing = width * narrowingWidth
    val heightNarrowing = height * narrowingHeight

    val points: SVGLine = listOf(
        widthMiddle to 0f, // top
        width - widthNarrowing to heightNarrowing, // right top
        width to height, // right bot
        0f to height, // left bot
        widthNarrowing to heightNarrowing, // left top
    )
    val resolvedStroke = strokeColor ?: backgroundColor
    Svg(
        attrs = Modifier
            .fillMaxSize()
            .overflow(Overflow.Visible)
            .then(modifier)
            .toAttrs {
                attr("viewBox", "0 0 $width $height")
                attr("preserveAspectRatio", "none")
            }
    ) {
        Defs {
            Filter(id = SvgId("badge-shadow")) {
                attr("x", "-20%")
                attr("y", "-20%")
                attr("width", "140%")
                attr("height", "140%")
                DropShadow {
                    attr("dx", "2")
                    attr("dy", "2")
                    attr("stdDeviation", "4")
                    attr("flood-color", "rgba(0,0,0,0.5)")
                }
            }
        }
        Polygon {
            attr("points", points.line())
            attr("fill", backgroundColor.toString())
            attr("stroke", resolvedStroke.toString())
            attr("stroke-width", strokeWidth.toString())
            attr("stroke-linejoin", "round")
            attr("filter", "url(#badge-shadow)")
            style {
                property(
                    "transition",
                    "fill $transitionDur, stroke $transitionDur"
                )
            }
        }
    }
}
